import clsx from 'clsx';

import {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState,
  useCallback
} from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CartLength from './CartLength';
import { addToCart, removeFromCart } from '../actions/cartActions';
import useAxios from '../axios/useAxios';
import paniervide from '../styles/img/paniervide.svg';
import { BottomSheet } from 'react-spring-bottom-sheet';
import {
  cartPrice,
  formatPriceWithEuro,
  truncate,
} from '../utils/StringUtils';
import moins_icon from '../styles/img/arrow/moins.svg';
import plus_icon from '../styles/img/arrow/plus.svg';
import { hasFidelityCard, isAllowedToPay, isStoreIntegrated, MINIMUM_PRICE } from '../utils/Validator';
import cartdelete from '../styles/img/cart_delete.svg';
import LoaderWithText from './loader/LoaderWithText';
import pikkocoin from '../styles/img/Pikkocoin.svg';
import CalculatePromoButton from './button/CalculatePromoButton';
import PromoAndPointsDisplay from './tile/PromoAndPointsDisplay';
import QuickAddProducts from './cart/QuickAddProducts';
import {
  ADD_FID_SCAN,
  CART, FIDCOUPON,
  INVITATION,
  PROMO,
  AMOUNT_CHANGE_JACKPOT,
  CREATE_FID_CARD_CASHBACK,
} from '../constants/routes';
import { IoInformationCircleOutline } from "react-icons/io5";
import { HiAdjustments } from "react-icons/hi";
import { useJackpotMatch } from '../hooks/useJackpotMatch';
import { calculateTotalToPay } from '../utils/order/orderUtils';
import JackpotPrompt from './pikko-jackpot/PikkoJackpotPrompt';
import JackpotLock from './pikko-jackpot/PikkoJackpotLock';
import JackpotTag from './pikko-jackpot/PikkoJackpotTag';
import { formatFidelityPoints } from '../utils/StringUtils';
import reload from '../styles/img/reloading.svg';
import Toggle from './Toggle';
import MidiDealCart from './midiDeal/MidiDealCart';

const FooterCart = ({ scanPause, handleResetToaster, theme, currentProduct, quickAddProducts = [] }, ref) => {

  const sheetRef = useRef(null);
  const axiosInstance = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loadingCart, cartItems } = useSelector((state) => state.cart);

  const calculateItemDisplayState = useCallback((item) => {
    const isMidiDealActive = cartItems?.midiDeal?.isActive && cartItems?.midiDeal?.items?.length === 3;
    const isItemInDeal = isMidiDealActive && cartItems?.midiDeal?.items?.some(dealItem => dealItem.barcode === item.Code_Barre);
    const dealQty = isItemInDeal ? 1 : 0;
    const displayQty = item.Qty - dealQty;

    return { displayQty, isItemInDeal };
  }, [cartItems?.midiDeal]);


  const { store } = useSelector((state) => state.store);
  const user = useSelector((state) => state.user);
  const [showCart, setShowCart] = useState(false);
  const [localQty,] = useState([]);
  const [lastCallTimestamp, setLastCallTimestamp] = useState(0);
  const [lastCallTime, setLastCallTime] = useState(0);
  const [cartChange, setCartChange] = useState(false);

  const SNAP = 'SNAP';
  const DONTLOOP = 'Dont_loop';
  const countItems = CartLength();
  const isAllowedToPurchase = isAllowedToPay(cartItems);


  const disablePurchaseButton = () => {
    return countItems === 0 || !isAllowedToPurchase;
  };

  const addToCartHandler = (event, product) => {
    event.stopPropagation();
    dispatch(addToCart(cartItems._id, product, 1, axiosInstance));
    setCartChange(true);
  };

  async function removeFromCartHandler(event, product_qty) {
    event.stopPropagation();

    const cbarre_qty = product_qty.map(({ product, qty }) => ({
      Code_Barre: product.Code_Barre,
      qty: qty,
    }));

    dispatch(
      removeFromCart(cbarre_qty, cartItems._id, product_qty, axiosInstance),
    );
    setCartChange(true);
  }

  const onClickInfooter = () => {
    handleResetToaster();
    if (store && countItems >= store?.item_limit) {
      scanPause(true);
    } else {
      scanPause(!showCart);
    }

    setShowCart(!showCart);
    if (showCart) {
      sheetRef.current.snapTo(100, { source: DONTLOOP });
    } else {
      sheetRef.current.snapTo(1000, { source: DONTLOOP });
    }
  };

  const forceOpenCart = () => {
    scanPause(true);
    setShowCart(true);
    sheetRef.current.snapTo(1000, { source: DONTLOOP });
  };


  const handleShowCart = () => {
    const now = Date.now();
    // Vérifie si moins de 500 millisecondes se sont écoulées depuis le dernier appel,c'est pour éviter les appels multiples
    if (now - lastCallTime < 500) {
      setLastCallTime(now); // Met à jour le temps du dernier appel de la fonction
      return;
    }
    if (showCart) {
      sheetRef.current.snapTo(100);
    } else {
      sheetRef.current.snapTo(1000);
    }
    setTimeout(() => {
      setShowCart(!showCart);
    }, 150);

    if (store && countItems < store?.item_limit) {
      // scanPause(!showCart);
    }
    // Met à jour le temps du dernier appel
    setLastCallTime(now);
  };

  useImperativeHandle(ref, () => ({
    onClickInfooter,
    handleShowCart,
    forceOpenCart
  }));

  const onclickExterior = () => {
    setShowCart(false);

    if (store && countItems >= store?.item_limit) {
      scanPause(true);
    } else {
      scanPause(false);
    }
    sheetRef.current.snapTo(100, { source: DONTLOOP });
  };

  const toPay = (e) => {
    e.stopPropagation();

    if (!showCart) {
      setShowCart(true);
      sheetRef.current.snapTo(1000, { source: DONTLOOP });
      return;
    }
    if (isStoreIntegrated(store) && hasFidelityCard(user)) navigate(FIDCOUPON)
    else if (!store?.permissions?.promo) navigate(CART);
    else if ((user?._id && user._id.length > 0)) navigate(PROMO);
    else navigate(INVITATION);
  };
  const handleCartChange = () => {
    setCartChange(false);
  };
  const addFidCardButton = (e) => {
    e.stopPropagation();
    navigate(ADD_FID_SCAN);
  };

  // INIT Jackpot Match
  const {
    isJackpotMatchActive,
    isLoadingFidCards,
    errorMessageFidCards,
    jackpotMatchSolde,
    jackpotMatchAmount,
    isShouldShowFidMatch,
    handleJackpotMatch,
    totalAddedToJackpot,
    hasProductsWithCashback,
    isFirstVisit,
  } = useJackpotMatch({
    axiosInstance,
    user,
    cartItems,
    store,
    shouldFetch: showCart && store && store?.api !== 'mongoDb',
  });


  const isFidelityCardAdded = showCart && isShouldShowFidMatch && hasFidelityCard(user);
  const isFidelityCardNotAdded = showCart && isShouldShowFidMatch && !hasFidelityCard(user);

  const FidelityCardSkeleton = () => {
    return (
      <>
        {/* Logo Skeleton */}
        <div className="flex items-start justify-center max-w-[55px] w-full h-[40px] bg-gradient-to-r from-gray-300 to-gray-400 rounded-2xl animate-pulse" />

        {/* User Info Skeleton */}
        <div className="flex gap-2 items-start justify-center flex-col flex-1">
          <div className="h-4 bg-gradient-to-r from-gray-300 to-gray-400 rounded w-32 animate-pulse" />
          <div className="h-3 bg-gradient-to-r from-gray-300 to-gray-400 rounded w-20 mt-1 animate-pulse" />
        </div>

        {/* Toggle Skeleton */}
        <div className="flex justify-end">
          <div className="h-6 w-12 bg-gradient-to-r from-gray-300 to-gray-400 rounded-full animate-pulse" />
        </div>
      </>
    );
  };


  const renderFidCardButtonNotAdded = () => {

    const price = hasProductsWithCashback() ? formatPriceWithEuro(totalAddedToJackpot()) : '10%';

    const showCashbackPrice = hasProductsWithCashback() && user?._id;

    const renderContent = () => {
      if (!user?._id) {
        return (
          <button
            type="button"
            className="add-fid-card-button"
            onClick={(e) => addFidCardButton(e)}
          >
            + Ajouter ma carte de fidélité
          </button>
        );
      }

      const displayPrice = showCashbackPrice ? price : '10%';
      return <JackpotPrompt price={displayPrice} navigationPath={CREATE_FID_CARD_CASHBACK} />;
    };

    return (
      <div className='flex fixed bottom-[80px] justify-center items-center w-[90%] rounded-[0.8em]'>
        {renderContent()}
      </div>
    );
  };

  const renderJackpotMatchInformation = () => {
    const isPromo = cartItems.promoPrice !== cartItems.itemsPrice;
    const maximumPrice = isPromo ? cartItems.promoPrice : cartItems.itemsPrice;
    const priceMaximumUsable = Math.min(Math.max(0, jackpotMatchSolde), maximumPrice);
    const amountToShow = isJackpotMatchActive ? jackpotMatchAmount : priceMaximumUsable;

    if (amountToShow === null || amountToShow === undefined || isNaN(amountToShow)) {
      return null;
    }

    return (
      <div className="flex items-center justify-start w-full">
        <div className="flex text-left pt-1 mr-4 justify-start text-[1.15em] geomanistMedium">
          {formatPriceWithEuro(amountToShow)}
        </div>

        <div className='flex items-center justify-center gap-[16px]'>
          {isJackpotMatchActive ?
            <div className="flex items-center justify-center">
              <HiAdjustments size={20} onClick={() => navigate(AMOUNT_CHANGE_JACKPOT)} />
            </div>
            : null}
          {totalAddedToJackpot() > 0 && (isFirstVisit || hasProductsWithCashback()) ? <JackpotTag price={"+" + (formatPriceWithEuro(totalAddedToJackpot()))} /> : null}
        </div>
      </div>
    );
  };

  const renderBasicFidCard = (nom, prenom, showJackpotInfo = false) => {
    return (
      <div className='flex items-center justify-between w-full'>
        <div className="flex items-center gap-4">
          <div className="flex items-start justify-center max-w-[60px] bg-white rounded-xl">
            <img className="w-full h-full object-contain" src={store.logo} alt="logo" />
          </div>
          <div className="geomanistBook text-[14px] text-[#0E0B26]">{nom}{' '}{prenom}</div>
        </div>

        {showJackpotInfo && (
          <div className="flex gap-2 items-center">
            <div className='flex items-center gap-4'>
              {totalAddedToJackpot() > 0 && <JackpotTag price={`+${formatPriceWithEuro(totalAddedToJackpot())}`} />}
              <p className="geomanistMedium text-[16px] text-[#0E0B26]">{formatPriceWithEuro(jackpotMatchSolde)}</p>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderJackpotMatchContent = () => {
    if (errorMessageFidCards && jackpotMatchSolde !== 0) {
      return (
        <div className="flex items-center justify-center w-full">
          <p className="text-zinc-500 geomanistRegular font-semibold text-[1.1em]">{errorMessageFidCards}</p>
          <button type="button" className="flex flex-1 justify-end geomanistMedium gap-2 text-green-700 items-center"
            onClick={(event) => handleJackpotMatch(event)}>
            <img src={reload} alt="reload" /> Recharger
          </button>
        </div>
      );
    }

    if (isLoadingFidCards) {
      return <FidelityCardSkeleton />;
    }

    const { nom, prenom } = user.fidCard[0].fidelityInfo.ficheClient;
    const isCreatedWithPikkoPay = user.fidCard[0].source && user.fidCard[0].source === 'webapp';

    if (jackpotMatchSolde === 0) {
      return renderBasicFidCard(nom, prenom, false);
    }

    if (isFirstVisit && isCreatedWithPikkoPay) {
      return renderBasicFidCard(nom, prenom, true);
    }

    return (
      <>
        <div className="flex items-start justify-center max-w-[55px] h-[40px] bg-white rounded-2xl">
          <img className="w-full h-full object-contain" src={store.logo} alt="logo" />
        </div>

        <div className="flex flex-col justify-between w-full">
          <div className="text-left geomanistRegular font-semibold">{nom}{' '}{prenom}</div>
          <div className="flex items-center justify-center gap-2">
            {renderJackpotMatchInformation()}
          </div>
        </div>

        <div className="flex flex-1 justify-end">
          <Toggle
            checked={isJackpotMatchActive}
            onChange={(event) => handleJackpotMatch(event)}
          />
        </div>
      </>
    );
  };

  const renderJackpotMatch = () => {
    if (!user?.fidCard?.[0]?.fidelityInfo?.ficheClient) {
      console.error('Fidélité Match: Fidélité card not found');
      return null;
    };

    return (
      <div className={clsx(
        "flex fixed bottom-[80px] justify-left items-center transition-all",
        "rounded-[0.6em] text-gray-500 border border-solid",
        "w-[90%] gap-4 px-4 py-3 my-2 text-[1.4em] overflow-hidden font-geomanistmedium",
        {
          "border-gray-200 bg-[#F3F3F4]": !isJackpotMatchActive && !errorMessageFidCards || isLoadingFidCards,
          "border-none bg-transparent py-0": errorMessageFidCards,
          "p-3 border-solid border-[1.5px] bg-[#A0FFDC] bg-opacity-70 border-[#5BB996/0.7]": isJackpotMatchActive,
        }
      )}>
        {renderJackpotMatchContent()}
      </div>
    );
  };

  const renderFidCardOrJackpotMatch = () => {
    const numeroClient = user?.fidCard?.[0]?.fidelityInfo?.numeroClient;

    if (numeroClient) return renderJackpotMatch();
    // if (numeroClient) return renderFidCardButtonAdded();

    return renderFidCardButtonNotAdded();
  };

  const renderTotalToPay = () => {
    const isPromo = cartItems.promoPrice < cartItems.itemsPrice;
    const isJackpotMatch = jackpotMatchAmount > 0;
    const totalToPay = calculateTotalToPay(cartItems.itemsPrice, cartItems.promoPrice, jackpotMatchAmount);

    return (
      <>
        {(isPromo || isJackpotMatch) && totalToPay > 0 && (
          <span className="promotion_sliced mr-2">
            {formatPriceWithEuro(cartItems.itemsPrice)}
          </span>
        )}
        {formatPriceWithEuro(totalToPay)}
      </>
    );
  };

  const isAllQuickAddProductsInCart = (products) => {
    return products.every(product => cartItems.orderItems.some(item => item.Code_Barre === product.Code_Barre));
  }

  return (
    <>
      <BottomSheet
        open
        ref={sheetRef}
        className={clsx("chart-slider rounded-t-[25px] relative z-[1509]",
          { "!opacity-0": currentProduct }
        )}
        onDismiss={onclickExterior}
        scrollLocking={false}
        blocking={showCart}
        defaultSnap={() => 120}
        snapPoints={({ maxHeight }) => [maxHeight * 0.9, 120]}
        onClick={handleResetToaster}
        skipInitialTransition
        expandOnContentDrag={!showCart}
        onSpringStart={(event) => {
          const currentTimestamp = Date.now();
          if (event.type === SNAP && event.source !== DONTLOOP) {
            handleShowCart();
            handleResetToaster();
            console.info('onSpringStart', currentTimestamp - lastCallTimestamp);
            setLastCallTimestamp(currentTimestamp);
          }
        }}
      >
        {store?.item_limit && !showCart ?
          <div className="flex justify-start items-center gap-2 absolute -top-[50px] left-[10px] px-[11px] py-[3px] rounded-full border-[2px] border-[#966C03] bg-[#FFE5A4]">
            <div>
              <IoInformationCircleOutline size={23} stroke="#966C03" fill="#966C03" />
            </div>
            <div className="text-[#966C03] text-xl">
              Maximum {store.item_limit} articles
            </div>
          </div> : null}

        {showCart && (
          <div className="header_footer_cart">
            <div className="flex flex-col">
              <span className="header_footer_cart_text">
                Panier
                {theme?.screenDecorations?.footerCartTitleIcon && (
                  <img
                    src={theme?.screenDecorations?.footerCartTitleIcon?.image}
                    alt="toile3"
                    className="sucette"
                  />
                )}
              </span>

              {store?.item_limit ?
                <small className="text-[15px]">(maximum {store.item_limit} articles)</small>
                : null}

              <span
                className="text-xl color-label open-sans"
                style={{
                  fontFamily: 'Open Sans',
                  color: '#9C9C9C',
                }}
              >
                {countItems > 1
                  ? `${countItems} articles`
                  : `${countItems} article`}
              </span>
            </div>

            <CalculatePromoButton
              store={store}
              cartItems={cartItems}
              axiosInstance={axiosInstance}
              showCart={showCart}
              isCartChanged={cartChange}
              handleCartChange={handleCartChange}
            />
            {theme?.screenDecorations?.footerCartTopDecoration && (
              <img
                src={theme?.screenDecorations?.footerCartTopDecoration?.image}
                alt="toile3"
                className="absolute right-0"
              />
            )}
          </div>
        )}
        {loadingCart && showCart && (
          // A mettre au milieu du panier
          <LoaderWithText type2={true} text="Chargement..." isRounded />
        )}

        <footer
          id="footerPanier"
          className={`footer-container relative bottom-0 duration-300 bg-white flex flex-col items-center
                    ${showCart ? 'open overflow-auto' : 'h-[8vh] overflow-hidden'}`}
          onClick={onClickInfooter}
          onKeyUp={onClickInfooter}
          onKeyDown={onClickInfooter}
        >

          {showCart ? (
            <>
              {loadingCart ? (
                <>
                  <div
                    className="absolute z-50 w-full h-full "
                    style={{ backgroundColor: 'rgba(0,0,0,0.1)' }}
                  >
                    <div className="z-50 absolute h-full left-2/4 top-[25%]  -translate-x-2/4 ">
                      <div className="lds-spinner white">
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                        <div />
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
              <>
                {/*<ul className="w-full relative h-full px-6 mb-[150px] flex flex-col">*/}
                {!hasFidelityCard(user) && hasProductsWithCashback() && user?._id && isStoreIntegrated(store) &&
                  <JackpotLock price={formatPriceWithEuro(totalAddedToJackpot())} />}
                {!hasFidelityCard(user) && isStoreIntegrated(store) && !hasProductsWithCashback() && cartItems.itemsPrice > 0 && user?._id && <JackpotLock price={"10 %"} />}
                <ul className="item-container">

                  {countItems ? (
                    <></>
                  ) : (
                    <div className="absolute transform translate-x-[-50%] translate-y-[-50%] top-[40%] left-[50%]">
                      <img src={paniervide} alt="" />
                    </div>
                  )}

                  {quickAddProducts.length > 0 && !isAllQuickAddProductsInCart(quickAddProducts) && cartItems.orderItems.length > 0 && (
                    <QuickAddProducts title="Cela pourrait t'intéresser" products={quickAddProducts} addToCartHandlerCallback={(event, product) => addToCartHandler(event, product)} />
                  )}

                  <MidiDealCart midiDeal={cartItems?.midiDeal} orderItems={cartItems?.orderItems} removeFromCartHandler={removeFromCartHandler} />

                  {cartItems?.orderItems.map((item, index) => {
                    const { displayQty } = calculateItemDisplayState(item);

                    if (displayQty <= 0) return null;

                    const hasFidCard = hasFidelityCard(user);
                    const hasCashback = item.cashbackAmount > 0;
                    const hasPromotion = item.promotion > 0;
                    const hasFidelityPoints = formatFidelityPoints(item.fidelity) >= 1;

                    const cashbackPrice = formatPriceWithEuro(item.cashbackAmount * displayQty);
                    const firstVisitCashbackPrice = formatPriceWithEuro(((item.price * displayQty) * 10) / 100);

                    const showCashbackTagWithoutPromo = hasCashback && !hasPromotion && !hasFidelityPoints && hasFidCard;
                    const showFirstVisitTagWithoutPromo = isFirstVisit && !hasCashback && !hasPromotion && !hasFidelityPoints && hasFidCard;

                    const showCashbackTagWithPromo = hasCashback && (hasPromotion || hasFidelityPoints) && hasFidCard;
                    const showFirstVisitTagWithPromo = isFirstVisit && !hasCashback && (hasPromotion || hasFidelityPoints) && hasFidCard;

                    return (
                      <li key={item.Code_Barre || item._id || index} className="mt-0">
                        <div
                          className="flex items-center justify-between px-2 bg-white cart_list overflow"
                          style={{ borderColor: item.CountInStock }}
                        >
                          <div className="flex items-center justify-center gap-8 overflow-hidden w-full">
                            <div className='flex w-fit'>
                              <img
                                src={item.image}
                                alt={item.image}
                                className="object-contain"
                                style={{ height: '55px', width: '55px' }}
                              />
                            </div>


                            <div className="py-[16px] ml-4 w-full">
                              <div
                                className="flex flex-col gap-4 text-xl text-left min-30"
                                style={{ fontFamily: 'Open Sans' }}
                              >
                                <div className='flex items-center gap-2'>
                                  {showCashbackTagWithoutPromo && (
                                    <JackpotTag price={"+" + cashbackPrice} icon={true} text="ajouté à ta cagnotte" />
                                  )}

                                  {showFirstVisitTagWithoutPromo && (
                                    <JackpotTag price={firstVisitCashbackPrice} icon={true} />
                                  )}

                                  <div className='flex items-center justify-center gap-2'>
                                    <PromoAndPointsDisplay
                                      item={item}
                                      pikkocoin={pikkocoin}
                                      user={user}
                                    />
                                    {showCashbackTagWithPromo && (
                                      <JackpotTag price={"+" + cashbackPrice} icon={true} />
                                    )}
                                    {showFirstVisitTagWithPromo && (
                                      <JackpotTag price={"+" + firstVisitCashbackPrice} icon={true} />
                                    )}
                                  </div>

                                </div>


                                <div className="flex w-full">
                                  <p className="geomanistBook text-[14px] text-[#0E0B26] max-w-[80%]">
                                    {truncate(item.name, 180)}
                                  </p>
                                </div>
                                <p className="cart-item-price flex justify-between w-full">
                                  <div>
                                    {item?.promoPrice >= 0 ? (
                                      <>
                                        {formatPriceWithEuro(
                                          item.promoPrice * displayQty,
                                        )}
                                      </>
                                    ) : (
                                      <>
                                        {formatPriceWithEuro(
                                          item.price * displayQty,
                                        )}
                                      </>
                                    )}

                                    {item.promoPrice && item.price && (
                                      <span className="promotion_sliced">
                                        {formatPriceWithEuro(
                                          item.price * displayQty,
                                        )}
                                      </span>
                                    )}
                                  </div>

                                  {item.price === 0 ? (
                                    <></>
                                  ) : (
                                    <div
                                      className="flex items-center gap-[2px]"
                                    >
                                      <button
                                        type="button"
                                        className="flex items-center justify-center w-[44px] h-[44px]"
                                        onClick={(event) =>
                                          removeFromCartHandler(event, [
                                            { product: item, qty: 1 },
                                          ])
                                        }
                                      >
                                        {displayQty === 1 ? (
                                          <>
                                            <img
                                              src={cartdelete}
                                              alt="delete"
                                              className="w-auto"
                                            />
                                          </>
                                        ) : (
                                          <img src={moins_icon} alt="" />
                                        )}
                                      </button>
                                      {localQty[index] ? (
                                        <span className="flex items-center justify-center h-full text-2xl text-center ">
                                          {localQty[index]}
                                        </span>
                                      ) : (
                                        <span className="flex items-center justify-center text-center text-[1.7rem] geomanistBold h-full">
                                          {displayQty}
                                        </span>
                                      )}
                                      {store && countItems >= store?.item_limit ? (
                                        <></>
                                      ) : (
                                        <button
                                          type="button"
                                          className="w-[44px] h-[44px]"
                                          onClick={(event) =>
                                            addToCartHandler(event, item)
                                          }
                                        >
                                          <img src={plus_icon} alt="" />
                                        </button>
                                      )}
                                    </div>
                                  )}

                                </p>

                              </div>
                            </div>
                          </div>
                        </div>
                      </li>
                    );
                  })}
                </ul>
              </>
            </>
          ) : (
            <></>
          )}
          {showCart && disablePurchaseButton() && (
            <div className="warning-message">{`Panier minimum de ${formatPriceWithEuro(
              MINIMUM_PRICE,
            )}`}</div>
          )}

          {showCart && (
            <div className="price_footer transition-all w-full gap-4  text-[1.7rem] geomanistMedium z-200" style={{
              height: store?.name.includes('Match') ? (errorMessageFidCards ? '150px' : '180px') : '130px',
            }}>
              <div className="flex items-center justify-around w-full gap-6 ">
                <div className="flex flex-col items-start w-full open-sans-bold">
                  <span className="color-label text-[16px] open-sans-bold ">
                    Total à payer{' '}
                  </span>
                </div>
                <div className="flex flex-col">
                  <p className="color-label text-[16px] open-sans-bold">
                    {renderTotalToPay()}
                  </p>
                </div>
              </div>
            </div>
          )}

          {isFidelityCardAdded ? renderFidCardOrJackpotMatch() : null}
          {isFidelityCardNotAdded ? renderFidCardButtonNotAdded() : null}

          <div
            className={`purchase-button-container
              ${showCart ?
                disablePurchaseButton() ?
                  'filter grayscale !rounded-[1.5em]' :
                  'payer p-6 pl-100 !rounded-[1.5em] bottom-btn-shadow'
                :
                <></>
              }`}
          >
            {showCart ?
              <></> : (
                <div className="flex items-center justify-center w-full">
                  <div
                    id="footerCart"
                    className="flex flex-col items-start justify-center w-full geomanistMedium inter"
                  >
                    <span className="text-[22px] open-sans-bold">Panier</span>
                    <div
                      className="text-xl  !text-[1.5rem]"
                      style={{
                        fontFamily: 'Open Sans ',
                        color: '#9C9C9C',
                      }}
                    >
                      {countItems > 1
                        ? `${countItems} articles`
                        : `${countItems} article`}
                    </div>
                  </div>
                  <div className=" text-[22px] open-sans-bold">
                    {formatPriceWithEuro(cartPrice(cartItems))}
                  </div>
                </div>
              )}

            <button
              type="button"
              onClick={toPay}
              disabled={disablePurchaseButton() && showCart}
              className={`purchase-button ${disablePurchaseButton() && showCart
                ? 'disabled'
                : showCart ? ''
                  : 'footer-cart-button bottom-btn-shadow'
                }`}
            >
              <div
                className={
                  showCart
                    ? ' color-label  w-[130px] text-[1.9rem] geomanistMedium'
                    : ' color-label  text-[1.7rem] w-[130px]  geomanistMedium'
                }
              >
                {showCart ? <>Valider/Payer</> : <>Voir mon panier</>}
              </div>
            </button>
          </div>
        </footer>
      </BottomSheet>
    </>
  );
};

export default forwardRef(FooterCart);
